import React from 'react';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LogoutIcon from '@mui/icons-material/Logout';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebaseConfig';
import Brand from './components/Brand';

/**
 * Shown when a signed-in user has no configured application role yet. Rather than exposing menus,
 * we ask them to have an administrator assign a role.
 */
export default function RoleNeeded({ email }) {
  const navigate = useNavigate();
  const logout = async () => {
    try { await signOut(auth); } catch (e) { /* ignore */ }
    navigate('/login');
  };

  return (
    <Box sx={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 460, textAlign: 'center' }}>
        <Box sx={{ mb: 2 }}><Brand fontSize={20} /></Box>
        <ManageAccountsIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
        <Typography variant="h6" gutterBottom>Your role needs to be configured</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {email ? <>Your account (<strong>{email}</strong>) isn’t assigned an application role yet.</>
            : 'Your account isn’t assigned an application role yet.'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Please contact your administrator to have a role assigned before you can access the app.
        </Typography>
        <Stack direction="row" spacing={1} justifyContent="center">
          <Button variant="outlined" startIcon={<LogoutIcon />} onClick={logout}>Sign out</Button>
        </Stack>
      </Paper>
    </Box>
  );
}
